import { useContext, useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";

import "../styles/SiteImages.css";

import { ModalContext, RestContext } from "../App";
import { DOC_URL } from "../serverConfig";
import { FileUploader } from "react-drag-drop-files";

function SiteImages({ site }) {
	const [images, setImages] = useState([]);

	const { sendGetRequest } = useContext(RestContext);
	const { openModal, setOpenModal } = useContext(ModalContext);

	const toggleUploadModal = () =>
		openModal === "site-image-upload-modal"
			? setOpenModal()
			: setOpenModal("site-image-upload-modal");

	useEffect(() => {
		if (site?.idNo) {
			sendGetRequest(
				DOC_URL + "/site/images/" + site.idNo,
				(response) => {
					setImages(response.data);
				},
			);
		}
	}, [site]);

	const onUpload = () => {
		sendGetRequest(DOC_URL + "/site/images/" + site.idNo, (response) => {
			setImages(response.data);
		});
	};

	const mapImages = () => {
		return images.map((image) => (
			<a
				className="site-image-wrapper"
				href={DOC_URL + "/preview/" + image.docId}
				target="_blank"
			>
				<img
					src={DOC_URL + "/preview/" + image.docId}
					alt={image.docName}
				/>
				<span>{image.docName}</span>
			</a>
		));
	};

	return (
		<div id="site-details-images">
			<div id="site-details-images-container">{mapImages()}</div>
			<Button id="site-images-upload-button" onClick={toggleUploadModal}>
				Upload Image
			</Button>
			<UploadModal
				siteId={site?.idNo}
				isOpen={openModal === "site-image-upload-modal"}
				toggle={toggleUploadModal}
				onUpload={onUpload}
			/>
		</div>
	);
}

function UploadModal({ siteId, isOpen, toggle, onUpload }) {
	const { sendPostRequest } = useContext(RestContext);

	const getDefaultDate = () => {
		const date = new Date();
		return date.toJSON().split("T")[0];
	};

	const handleChange = (files) => {
		let docs = [];
		let docTypes = {};
		let docDates = {};
		for (let file of files) {
			if (!docs.some((doc) => doc.name === file.name)) {
				docs.push(file);
				docTypes[file.name] = "SITE_IMAGE";
				docDates[file.name] = getDefaultDate();
			}
		}

		const fileTypes = Object.keys(docTypes).map(
			(docName) => docName + "=" + docTypes[docName],
		);
		const fileTypeString = fileTypes.join(";");
		const fileDates = Object.keys(docDates).map(
			(docName) => docName + "=" + docDates[docName] + " 06:00:00",
		);
		const fileDateString = fileDates.join(";");
		const formData = new FormData();
		for (let doc of docs) {
			formData.append("files", doc);
		}
		formData.append("fileTypes", fileTypeString);
		formData.append("fileDates", fileDateString);
		sendPostRequest(DOC_URL + "/upload/" + siteId, formData, (response) => {
			onUpload();
			toggle();
		});
	};

	return (
		<Modal id="site-image-upload-modal" isOpen={isOpen} toggle={toggle}>
			<ModalHeader toggle={toggle}>Upload Image</ModalHeader>
			<ModalBody>
				<FileUploader
					handleChange={handleChange}
					classes="file-upload"
					name="file"
					types={["PNG", "JPG", "JPEG", "BMP", "GIF", "HEIC", "HEIF"]}
					multiple
				/>
			</ModalBody>
		</Modal>
	);
}

export default SiteImages;
